// import React, { useState } from "react";

// const HlcScene = () => {
//   const [activeIndex, setActiveIndex] = useState(0);

//   const backgrounds = [
//     {
//       src: "https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/10/Day-View-All-Lights-Off.png",
//       alt: "Day View — All Lights Off",
//     },
//     {
//       src: "https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/10/Night-View-All-Lights-Off.png",
//       alt: "Night View — All Lights Off",
//     },
//     {
//       src: "https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/10/Night-View-Only-Wall-Lights-On.png",
//       alt: "Night View — Wall Lights On",
//     },
//     {
//       src: "https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/10/Night-View-Only-Fan-Light-and-Park-lights-on-Wall-Lights-Off.png",
//       alt: "Night View — Fan & Park Lights On",
//     },
//     {
//       src: "https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/10/Night-View-All-Lights-On.png",
//       alt: "Night View — All Lights On",
//     },
//   ];

//   const modes = [
//     "Day — Off",
//     "Night — Off",
//     "Wall On",
//     "Landscape On",
//     "All On",
//   ];

//   return (
//     <>
//       <section className="scene-viewer-section" id="scene-viewer-section">
//         {/* Background Images */}
//         {backgrounds.map((bg, index) => (
//           <img
//             key={index}
//             decoding="async"
//             className={`scene-viewer-bg ${activeIndex === index ? "scene-viewer-bg--show" : ""}`}
//             src={bg.src}
//             alt={bg.alt}
//           />
//         ))}

//         {/* Overlay */}
//         <div className="scene-viewer-overlay"></div>

//         {/* Copy */}
//         <div className="scene-viewer-copy">
//           <p className="scene-viewer-eyebrow">Enhanced Outdoor Spaces</p>
//           <h2 className="scene-viewer-heading">Outdoor Living Room</h2>
//         </div>

//         {/* Controls */}
//         <div
//           className="scene-viewer-controls"
//           role="tablist"
//           aria-label="Lighting modes"
//         >
//           {modes.map((mode, index) => (
//             <button
//               key={index}
//               className={`scene-viewer-chip ${
//                 activeIndex === index ? "scene-viewer-chip--active" : ""
//               }`}
//               role="tab"
//               aria-selected={activeIndex === index}
//               aria-controls={`mode-${index}`}
//               onClick={() => setActiveIndex(index)}
//             >
//               {mode}
//             </button>
//           ))}
//         </div>
//       </section>

// <style>{`
//   :root {
//     --scene-magenta: #9b1f6c;
//     --scene-ink: #141320;
//   }

//   #scene-viewer-section {
//     position: relative;
//     width: 100vw;
//     left: 50%;
//     right: 50%;
//     margin-left: -50vw;
//     margin-right: -50vw;
//     min-height: 100vh;
//     overflow: hidden;
//     background: #000;
//     color: #fff;
//     display: grid;
//     place-items: center;
//     font-family: "Open Sans", system-ui, Arial, sans-serif;
//   }

//   #scene-viewer-section .scene-viewer-bg {
//     position: absolute;
//     inset: 0;
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//     opacity: 0;
//     transition: opacity 0.45s ease;
//     will-change: opacity;
//     display: block;
//   }

//   #scene-viewer-section .scene-viewer-bg--show {
//     opacity: 1;
//   }

//   #scene-viewer-section .scene-viewer-overlay {
//     position: absolute;
//     inset: 0;
//     pointer-events: none;
//     background: linear-gradient(
//       180deg,
//       rgba(0, 0, 0, 0.38) 0%,
//       rgba(0, 0, 0, 0.42) 45%,
//       rgba(0, 0, 0, 0.55) 100%
//     );
//   }

//   #scene-viewer-section .scene-viewer-copy {
//     position: relative;
//     z-index: 2;
//     width: min(1100px, 92%);
//     align-self: start;
//     margin-top: clamp(48px, 8vw, 90px);
//     text-align: left;
//   }

//   #scene-viewer-section .scene-viewer-eyebrow {
//     margin: 0 0 6px;
//     font-size: 13px;
//     letter-spacing: 0.18em;
//     text-transform: uppercase;
//     opacity: 0.9;
//   }

//   #scene-viewer-section .scene-viewer-heading {
//     margin: 0;
//     color: #fff;
//     font-weight: 600;
//     font-size: clamp(28px, 5.2vw, 58px);
//     line-height: 1.1;
//   }

//   #scene-viewer-section .scene-viewer-controls {
//     position: relative;
//     z-index: 2;
//     width: min(1100px, 92%);
//     margin-inline: auto;
//     display: flex;
//     flex-wrap: wrap;
//     gap: 10px;
//     justify-content: center;
//     align-self: end;
//     margin-top: clamp(20px, 4vw, 30px);
//     margin-bottom: clamp(24px, 5vw, 42px);
//   }

//   #scene-viewer-section .scene-viewer-chip {
//     appearance: none;
//     cursor: pointer;
//     user-select: none;
//     padding: 10px 16px;
//     font-weight: 600;
//     font-size: 14px;
//     letter-spacing: 0.2px;
//     color: #fff;
//     background: rgba(20, 19, 32, 0.25);
//     border: 1.5px solid rgba(255, 255, 255, 0.55);
//     border-radius: 0;
//     transition: background 0.25s ease, border-color 0.25s ease;
//     white-space: nowrap;
//   }

//   #scene-viewer-section .scene-viewer-chip:hover {
//     background: rgba(255, 255, 255, 0.16);
//   }

//   #scene-viewer-section .scene-viewer-chip--active {
//     background: var(--scene-magenta);
//     border-color: var(--scene-magenta);
//   }

//   #scene-viewer-section .scene-viewer-chip:focus-visible {
//     outline: 2px solid #fff;
//     outline-offset: 2px;
//   }

//   #scene-viewer-section img {
//     max-width: none;
//   }

//   /* ================= MOBILE FIX ================= */
//  @media (max-width: 720px) {

//   #scene-viewer-section {
//     min-height: 88vh;
//   }

//   #scene-viewer-section .scene-viewer-copy {
//     margin-top: 32px;
//     text-align: center;
//   }

//   #scene-viewer-section .scene-viewer-heading {
//     font-size: clamp(24px, 7vw, 40px);
//   }

//   /* ================= 3 + 2 GRID LAYOUT ================= */
//   #scene-viewer-section .scene-viewer-controls {
//     display: grid;              /* 🔥 switch to grid */
//     grid-template-columns: repeat(3, 1fr);
//     gap: 6px;
//     justify-items: center;
//     margin-top: 16px;
//     margin-bottom: 18px;
//   }

//   /* force last row to naturally become 2 items */
//   #scene-viewer-section .scene-viewer-chip {
//     width: 100%;
//     max-width: 110px;
//     padding: 6px 8px;
//     font-size: 11px;
//     white-space: nowrap;
//   }

//   /* optional: make last 2 buttons align nicely */
//   #scene-viewer-section .scene-viewer-controls button:nth-child(4),
//   #scene-viewer-section .scene-viewer-controls button:nth-child(5) {
//     grid-column: span 1;
//   }
// }

// @media (max-width: 420px) {
//   #scene-viewer-section .scene-viewer-chip {
//     font-size: 10px;
//     padding: 5px 6px;
//   }
// }
//   @media (max-width: 420px) {
//     #scene-viewer-section {
//       min-height: 84vh;
//     }

//     #scene-viewer-section .scene-viewer-chip {
//       padding: 5px 8px;
//       font-size: 10px;
//     }
//   }

//   @media (prefers-reduced-motion: reduce) {
//     #scene-viewer-section .scene-viewer-bg {
//       transition: none;
//     }
//   }
// `}</style>
//     </>
//   );
// };

// export default HlcScene;

import React, { useState } from "react";
import dayView from "../assets/Day View - All Lights Off.png"; // adjust path
// import src\assets\Night View - All Lights Off.png
// src\assets\Night View - All Lights On.png
// src\assets\Night View Only Fan Light and Park lights on - Wall Lights Off.png
// src\assets\Night View Only Wall Lights On.png
//import dayView from "../assets/Day View - All Lights Off.png";
import nightOff from "../assets/Night View - All Lights Off.png";
import wallOn from "../assets/Night View Only Wall Lights On.png";
import landscapeOn from "../assets/Night View Only Fan Light and Park lights on - Wall Lights Off.png";
import allOn from "../assets/Night View - All Lights On.png";


const HlcScene = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // const backgrounds = [
  //   {
  //     //src: "https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/10/Day-View-All-Lights-Off.png",
  //     //src:"https://www.hlcpk.com/wp-content/uploads/2025/10/Day-View-All-Lights-Off.png",
  //     src:dayView,
  //     alt: "Day View — All Lights Off",
  //   },
  //   {
  //     src: "https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/10/Night-View-All-Lights-Off.png",
  //     alt: "Night View — All Lights Off",
  //   },
  //   {
  //     src: "https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/10/Night-View-Only-Wall-Lights-On.png",
  //     alt: "Night View — Wall Lights On",
  //   },
  //   {
  //     src: "https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/10/Night-View-Only-Fan-Light-and-Park-lights-on-Wall-Lights-Off.png",
  //     alt: "Night View — Fan & Park Lights On",
  //   },
  //   {
  //     src: "https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/10/Night-View-All-Lights-On.png",
  //     alt: "Night View — All Lights On",
  //   },
  // ];



  const backgrounds = [
  {
    src: dayView,
    alt: "Day View — All Lights Off",
  },
  {
    src: nightOff,
    alt: "Night View — All Lights Off",
  },
  {
    src: wallOn,
    alt: "Night View — Wall Lights On",
  },
  {
    src: landscapeOn,
    alt: "Night View — Fan & Park Lights On",
  },
  {
    src: allOn,
    alt: "Night View — All Lights On",
  },
];



  const modes = [
    "Day — Off",
    "Night — Off",
    "Wall On",
    "Landscape On",
    "All On",
  ];

  return (
    <>
      <section className="scene-viewer-section" id="scene-viewer-section">
        {/* Background Images */}
        {backgrounds.map((bg, index) => (
          <img
            key={index}
            decoding="async"
            loading="lazy"
            className={`scene-viewer-bg ${activeIndex === index ? "scene-viewer-bg--show" : ""}`}
            src={bg.src}
            alt={bg.alt}
          />
        ))}

        {/* Overlay */}
        <div className="scene-viewer-overlay"></div>

        {/* Copy */}
        <div className="scene-viewer-copy">
          <p className="scene-viewer-eyebrow">Enhanced Outdoor Spaces</p>
          <h2 className="scene-viewer-heading">Outdoor Living Room</h2>
        </div>

        {/* Controls */}
        <div
          className="scene-viewer-controls"
          role="tablist"
          aria-label="Lighting modes"
        >
          {modes.map((mode, index) => (
            <button
              key={index}
              className={`scene-viewer-chip ${
                activeIndex === index ? "scene-viewer-chip--active" : ""
              }`}
              role="tab"
              aria-selected={activeIndex === index}
              aria-controls={`mode-${index}`}
              onClick={() => setActiveIndex(index)}
            >
              {mode}
            </button>
          ))}
        </div>
      </section>

<style>{`
  :root {
    --scene-magenta: #9b1f6c;
    --scene-ink: #141320;
  }

  #scene-viewer-section {
    position: relative;
    width: 100vw;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    min-height: 100vh;
    overflow: hidden;
    background: #000;
    color: #fff;
    display: grid;
    place-items: center;
    font-family: "Open Sans", system-ui, Arial, sans-serif;
  }

  #scene-viewer-section .scene-viewer-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transition: opacity 0.45s ease;
    will-change: opacity;
    display: block;
  }

  #scene-viewer-section .scene-viewer-bg--show {
    opacity: 1;
  }

  #scene-viewer-section .scene-viewer-overlay {
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.38) 0%,
      rgba(0, 0, 0, 0.42) 45%,
      rgba(0, 0, 0, 0.55) 100%
    );
  }

  #scene-viewer-section .scene-viewer-copy {
    position: relative;
    z-index: 2;
    width: min(1100px, 92%);
    align-self: start;
    margin-top: clamp(48px, 8vw, 90px);
    text-align: left;
  }

  #scene-viewer-section .scene-viewer-eyebrow {
    margin: 0 0 6px;
    font-size: 13px;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    opacity: 0.9;
  }

  #scene-viewer-section .scene-viewer-heading {
    margin: 0;
    color: #fff;
    font-weight: 600;
    font-size: clamp(28px, 5.2vw, 58px);
    line-height: 1.1;
  }

  #scene-viewer-section .scene-viewer-controls {
    position: relative;
    z-index: 2;
    width: min(1100px, 92%);
    margin-inline: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
    align-self: end;
    margin-top: clamp(20px, 4vw, 30px);
    margin-bottom: clamp(24px, 5vw, 42px);
  }

  #scene-viewer-section .scene-viewer-chip {
    appearance: none;
    cursor: pointer;
    user-select: none;
    padding: 10px 16px;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.2px;
    color: #fff;
    background: rgba(20, 19, 32, 0.25);
    border: 1.5px solid rgba(255, 255, 255, 0.55);
    border-radius: 0;
    transition: background 0.25s ease, border-color 0.25s ease;
    white-space: nowrap;
  }

  #scene-viewer-section .scene-viewer-chip:hover {
    background: rgba(255, 255, 255, 0.16);
  }

  #scene-viewer-section .scene-viewer-chip--active {
    background: var(--scene-magenta);
    border-color: var(--scene-magenta);
  }

  #scene-viewer-section .scene-viewer-chip:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
  }

  #scene-viewer-section img {
    max-width: none;
  }

  /* ================= MOBILE FIX ================= */
 @media (max-width: 720px) {

  #scene-viewer-section {
    min-height: 88vh;
  }

  #scene-viewer-section .scene-viewer-copy {
    margin-top: 32px;
    text-align: center;
  }

  #scene-viewer-section .scene-viewer-heading {
    font-size: clamp(24px, 7vw, 40px);
  }

  /* ================= 3 + 2 GRID LAYOUT ================= */
  #scene-viewer-section .scene-viewer-controls {
    display: grid;              /* 🔥 switch to grid */
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
    justify-items: center;
    margin-top: 16px;
    margin-bottom: 18px;
  }

  /* force last row to naturally become 2 items */
  #scene-viewer-section .scene-viewer-chip {
    width: 100%;
    max-width: 110px;
    padding: 6px 8px;
    font-size: 11px;
    white-space: nowrap;
  }

  /* optional: make last 2 buttons align nicely */
  #scene-viewer-section .scene-viewer-controls button:nth-child(4),
  #scene-viewer-section .scene-viewer-controls button:nth-child(5) {
    grid-column: span 1;
  }
}

@media (max-width: 420px) {
  #scene-viewer-section .scene-viewer-chip {
    font-size: 10px;
    padding: 5px 6px;
  }
}
  @media (max-width: 420px) {
    #scene-viewer-section {
      min-height: 84vh;
    }

    #scene-viewer-section .scene-viewer-chip {
      padding: 5px 8px;
      font-size: 10px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    #scene-viewer-section .scene-viewer-bg {
      transition: none;
    }
  }
`}</style>
    </>
  );
};

export default HlcScene;
